enum TipoArmazemEnum {
  Recebimento = 1,
  Expedicao = 2,
  Biomassa = 3,
}

export default TipoArmazemEnum
